export interface GlobalRedirect {
  from?: string
  to?: string
  statusCode?: string | number
}

export const findGlobalRedirect = (
  redirects: GlobalRedirect[] | undefined,
  route: { path: string; fullPath?: string },
) => redirects?.find((redirect) => redirect.from === route.path)
